import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout.jsx';
import Home from './pages/Home.jsx';
import Fysioterapi from './pages/Fysioterapi.jsx';
import PersonligTraening from './pages/PersonligTraening.jsx';
import Forloeb from './pages/Forloeb.jsx';
import About from './pages/About.jsx';
import Contact from './pages/Contact.jsx';
import Galleri from './pages/Galleri.jsx';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="fysioterapi" element={<Fysioterapi />} />
        <Route path="om-ems-traening" element={<PersonligTraening />} />
        <Route path="priser" element={<Forloeb />} />
        <Route path="galleri" element={<Galleri />} />
        <Route path="om-os" element={<About />} />
        <Route path="kontakt" element={<Contact />} />
        
        {/* Redirects fra gamle stier */}
        <Route path="priser-1" element={<Navigate to="/priser" replace />} />
        <Route path="ems-træning-frederiksberg" element={<Navigate to="/om-ems-traening" replace />} />
        <Route path="ems-tr%C3%A6ning-frederiksberg" element={<Navigate to="/om-ems-traening" replace />} />
        <Route path="members" element={<Navigate to="/priser" replace />} />
        <Route path="team-4" element={<Navigate to="/om-os" replace />} />
        <Route path="service-page/fysioterapi-første-konsultation" element={<Navigate to="/fysioterapi" replace />} />
        <Route path="service-page/fysioterapi-f%C3%B8rste-konsultation" element={<Navigate to="/fysioterapi" replace />} />
        <Route path="service-page/sportsmassage" element={<Navigate to="/priser" replace />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export default App;
